// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

// Strips the leading slash so a route can be used as a relative <Route path>.
export const relative = (route: string) => route.replace(/^\//, '')

// Preferred name for the base route constant — the ROUTEOWNERS_SENTRY generator
// tries this name first. Any other name also works (the generator falls back to
// the first path constant in the file), but `baseRoute` is the convention.
const baseRoute = '/virtual-testing'

// Grouped by what a user is doing: looking at and rerunning postprocessing, or
// setting up simulations. The flat routes from before still redirect, see
// `VirtualTestingAreaContentView`.
export const BaseVirtualTestingAreaRoutes = {
  route: baseRoute,
  Postprocessing: {
    route: '/postprocessing',
    Results: {
      route: '/results',
      MeasurementDetails: {
        route: '/measurements/:analysisUuid',
      },
    },
  },
  Simulation: {
    route: '/simulation',
    Scenarios: {
      route: '/scenarios',
    },
  },
}

export const VirtualTestingAreaRoutes = transformRoutes(
  BaseVirtualTestingAreaRoutes,
)
